import { supabase } from '@/integrations/supabase/client';

function getRefFromUrl(url: string) {
  return url.replace('https://', '').split('.')[0]; // e.g. yhcymqfdigeufzooutxi
}

export async function edgeInvoke<T = any>(
  name: string,
  body?: unknown,
  init?: RequestInit
): Promise<T> {
  const supabaseUrl = "https://yhcymqfdigeufzooutxi.supabase.co";
  const ref = getRefFromUrl(supabaseUrl);
  const base = `https://${ref}.supabase.co/functions/v1`;

  // attach bearer (Verify JWT ON) if present
  const { data: { session } } = await supabase.auth.getSession();
  const headers: Record<string, string> = {
    'Content-Type': 'application/json',
    ...(init?.headers as Record<string,string> || {}),
  };
  if (session?.access_token) headers['Authorization'] = `Bearer ${session.access_token}`;

  const url = `${base}/${name}`;
  console.log('[edgeInvoke] Calling:', { url, name, method: 'POST', hasBody: !!body });
  
  try {
    const res = await fetch(url, {
      method: 'POST',
      headers,
      body: JSON.stringify(body ?? {}),
      ...init,
    });

    const text = await res.text();
    let json: any;
    try { json = JSON.parse(text); } catch { json = text; }

    if (!res.ok) {
      console.error('[edgeInvoke] Error response:', { name, status: res.status, text });
      throw new Error(`Edge ${name} ${res.status}: ${text}`);
    }
    return json as T;
  } catch (error) {
    console.error('[edgeInvoke] Fetch failed:', { name, url, error });
    if (error instanceof TypeError && error.message.includes('Failed to fetch')) {
      throw new Error(`Network error calling ${name}. Check CORS and function deployment.`);
    }
    throw error;
  }
}

// Optional: GET helper for health/debug routes
export async function edgeGet<T = any>(
  path: string, // e.g. 'playback-url/health' or 'admin-users-list'
  init?: RequestInit
): Promise<T> {
  const supabaseUrl = "https://yhcymqfdigeufzooutxi.supabase.co";
  const ref = getRefFromUrl(supabaseUrl);
  const base = `https://${ref}.supabase.co/functions/v1`;

  const { data: { session } } = await supabase.auth.getSession();
  const headers: Record<string, string> = {
    ...(init?.headers as Record<string,string> || {}),
  };
  if (session?.access_token) headers['Authorization'] = `Bearer ${session.access_token}`;

  const fullUrl = `${base}/${path}`;
  console.log('edgeGet calling:', { fullUrl, method: 'GET', headers });
  
  const res = await fetch(fullUrl, { method: 'GET', headers, ...init });
  const text = await res.text();
  let json: any;
  try { json = JSON.parse(text); } catch { json = text; }

  if (!res.ok) throw new Error(`Edge GET ${path} ${res.status}: ${text}`);
  return json as T;
}